export { useGDPRStore } from "./store";
